module.exports = __webpack_public_path__ + "img/cca-java-level-2.115abb07.png";